import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DialogOverlay, TextField } from '@fs/zion-ui'
import { MenuFilter } from '@fs/zion-icon'
import FactOptionGroup from './FactOptionGroup'

const FilterFactOptionsOverlay = ({ fieldListOverlay, factOptions, fieldArrayMethods }) => {
  const [t] = useTranslation()
  const [filterText, setFilterText] = useState('')

  return (
    <DialogOverlay
      {...fieldListOverlay}
      onClose={() => setFilterText('')}
      title={t('additional-facts-card.filter-facts.aria-label', 'Select Additional Facts')}
    >
      <TextField
        Icon={MenuFilter}
        placeholder={t('additional-facts-card.filter-facts', 'Filter Facts')}
        label={t('additional-facts-card.filter-facts', 'Filter Facts')}
        alt={t('additional-facts-card.filter-facts', 'Filter Facts')}
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
      />
      <FactOptionGroup
        groupLabel={t('additional-facts-card.common-facts', 'Common Facts')}
        facts={factOptions.commonFacts}
        filterText={filterText}
        fieldArrayMethods={fieldArrayMethods}
      />
      <FactOptionGroup
        groupLabel={t('additional-facts-card.other-facts', 'Other Facts')}
        facts={factOptions.otherFacts}
        filterText={filterText}
        fieldArrayMethods={fieldArrayMethods}
      />
    </DialogOverlay>
  )
}
export default FilterFactOptionsOverlay
